import React from 'react';
import FileIcon from '../Icons/FileIcon';
import CrossIcon from '../Icons/CrossIcon';

interface Props {
  selectedFile: File[];
  handleClearFile: () => void;
}

const LoadedFile: React.FC<Props> = ({ selectedFile, handleClearFile }) => {
  return (
    <div className="loaded-csv">
      <div className="icon-wrapper">
        <FileIcon />
      </div>
      <div className="middle-wrapper">
        <div className="filename">
          <p>{selectedFile[0].name}</p>
          {/* <span>csv</span> */}
        </div>
        <span className="file-type">Arquivo .txt</span>
      </div>
      <div onClick={handleClearFile}>
        <CrossIcon />
      </div>
    </div>
  );
};

export default LoadedFile;
